import {
  GET_ALL_EWAY_TRANSACTION,
  ADD_EWAY_TRANSACTION,
  UPDATE_EWAY_TRANSACTION,
  UPDATE_STATUS_EWAY_TRANSACTION,
  DELETE_EWAY_TRANSACTION,
} from "../types";
const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_EWAY_TRANSACTION:
      return { ...state, list: payload };

    case UPDATE_EWAY_TRANSACTION:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    case UPDATE_STATUS_EWAY_TRANSACTION:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item
        ),
      };

    case ADD_EWAY_TRANSACTION:
      return {
        ...state,
        list: [payload, ...state.list],
      };

    case DELETE_EWAY_TRANSACTION:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
      };

    default:
      return state;
  }
};

export default reducer;
